import { showAlert } from '../../store/modules/alert/actions'
const alertPlugin = (app, options = {}) => {
  app.$ShowAlert = showAlert
  app.config.globalProperties.$ShowAlert = showAlert
  app.provide('$ShowAlert', showAlert)
}

export default alertPlugin
